import fintectureLogo from 'assets/images/fintecture.png'
import safeConnectLogo from 'assets/images/SafeConnect.png'
import { CeruleanButton, WhiteButton } from 'components/Button'
import I18n from 'components/I18n'
import Arrow, { ArrowSide } from 'components/Icons/Arrow'
import messages from 'lang'
import React from 'react'
import styled from 'styled-components'

import { Header, ModalTitle } from '../../styles'
import CollapseGroup from './CollapseGroup'

const Img = styled.img`
  margin-right: 1.5rem;
`

const Footer = styled.div`
  margin-top: 1rem;

  button {
    width: 100%;
  }
`

type Props = {
  entity: string
  expireDate?: string
  onAccept: () => void
  onDecline: () => void
}
const Agreement = ({ entity, expireDate, onAccept, onDecline }: Props) => (
  <>
    <Header>
      <Arrow onClick={onDecline} side={ArrowSide.LEFT} />
      <Img src={entity.toLowerCase().includes('safeconnect') ? safeConnectLogo : fintectureLogo} />
      <ModalTitle>{entity}</ModalTitle>
    </Header>
    <main>
      <CollapseGroup expandFirst header='Data Sharing'>
        <I18n data={messages.link_bank_agreement_data_sharing} entity={entity} />
      </CollapseGroup>
      <CollapseGroup header='Secure Connection'>
        <I18n data={messages.link_bank_agreement_secure_connection} />
      </CollapseGroup>
      <CollapseGroup header='FCA Authorisation'>
        <p>
          <I18n data={messages.link_bank_agreement_fca_auth_1} entity={entity} />
        </p>
        <p>
          <I18n data={messages.link_bank_agreement_fca_auth_2} entity={entity} />
        </p>
        <ul>
          <li>
            <I18n data={messages.link_bank_agreement_fca_auth_id_details} />
          </li>

          <li>
            <I18n data={messages.link_bank_agreement_fca_auth_acc_details} />
          </li>
        </ul>
      </CollapseGroup>
      <CollapseGroup header='About the access'>
        {expireDate ? (
          <I18n
            data={messages.link_bank_agreement_access_expire}
            date={expireDate}
            entity={entity}
          />
        ) : (
          <I18n
            data={messages.link_bank_agreement_access_noexpire}
            date={expireDate}
            entity={entity}
          />
        )}
      </CollapseGroup>
    </main>
    <Footer>
      <CeruleanButton onClick={onAccept}>
        <I18n data={messages.button_accept} />
      </CeruleanButton>
      <WhiteButton onClick={onDecline}>
        <I18n data={messages.button_decline} />
      </WhiteButton>
    </Footer>
  </>
)

export default Agreement
